import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";

import { useFlightSelectionPayloadContext } from "@/app/lib/context/FlightSelectionPayloadContext/FlightSelectionPayloadContext";
import { useTravellersSelectionContext } from "@/app/lib/context/TravellersSelectionContext";
import { useSelectedDepartureFlight } from "@/app/lib/hooks/flightSearch/useSelectedDepartureFlight";
import { useSelectedReturnFlight } from "@/app/lib/hooks/flightSearch/useSelectedReturnFlight";
import { flightAvailabilityQueryOptions } from "@/app/lib/hooks/useFlightAvailability";
import { validateOrderId } from "@/app/lib/routeValidation";
import FlightBookSuccess from "@/app/ui/flight-purchase/FlightBookSuccess";

export const Route = createFileRoute(
  "/_authenticated/_flights/_flight-offer/flights/offer/$id/step/final",
)({
  validateSearch: validateOrderId,
  component: RouteComponent,
  staticData: {
    drawer: false,
  },
});

function RouteComponent() {
  const { orderId } = Route.useSearch();

  const { selectedFlightPayload } = useFlightSelectionPayloadContext();
  const { result: selectedDepartureFlight } = useSelectedDepartureFlight();
  const { result: selectedReturnFlight } = useSelectedReturnFlight();
  const { data: singleFlightDetails } = useQuery(
    flightAvailabilityQueryOptions(selectedFlightPayload),
  );

  const { selectedTravellers } = useTravellersSelectionContext();

  return (
    <FlightBookSuccess
      singleFlightDetails={singleFlightDetails}
      departureFlight={selectedDepartureFlight}
      returnFlight={selectedReturnFlight}
      departureStops={selectedDepartureFlight?.stops || []}
      returnStops={selectedReturnFlight?.stops || []}
      selectedTravellers={selectedTravellers}
      orderId={orderId}
    />
  );
}
